module.exports = __webpack_public_path__ + "img/no_logo_user.10421cb6.png";